/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Showcase_Reviews_TitleInputs */

const en_meta_showcase_reviews_title = /** @type {(inputs: Meta_Showcase_Reviews_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guest Review Aggregation for Hotel Websites | Lindevo`)
};

const lv_meta_showcase_reviews_title = /** @type {(inputs: Meta_Showcase_Reviews_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viesu atsauksmes viesnīcas mājaslapā — demo | Lindevo`)
};

/**
* | output |
* | --- |
* | "Guest Review Aggregation for Hotel Websites \| Lindevo" |
*
* @param {Meta_Showcase_Reviews_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_showcase_reviews_title = /** @type {((inputs?: Meta_Showcase_Reviews_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Showcase_Reviews_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_showcase_reviews_title(inputs)
	return en_meta_showcase_reviews_title(inputs)
});